var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Kein Mandant ausgewählt!")]),_vm._v(" Diese Seite steht nur zur Verfügung, wenn ein Mandant ausgewählt wurde. ")])
}]

export { render, staticRenderFns }